module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e97cbeda206c8637879f8db5477d494f.png";